export enum ProductLKType {
    Sales = 1,
    Technical = 2,
    PreSales = 3,
}
